import React, { useEffect, useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import "dayjs/locale/he";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import inputWriteIcon from "../assets/images/writeIcon.svg";
import axios from 'axios';

const Profile = ({ commonStyles, setFormValues, formValues, userIDNum }) => {
  const [inputSize, setInputSize] = useState(window.innerWidth < 1460 ? 'small' : 'normal');

  useEffect(() => {
    const handleResize = () => {
      setInputSize(window.innerWidth < 1460 ? 'small' : 'normal');
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleInputChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const theme = createTheme({
    direction: 'rtl',
  });

  return (
    <>
      <div className='pro_info_div'>
        <h1>הפרופיל שלי</h1>
        <p>אלה הפרטים ששמורים אצלנו, וזה המקום לשנות ולעדכן אותם:</p>
      </div>

      <div className='pro_inputs'>
        <div className='pro_row_input'>
          <div className='pro_input'>
            <label>שם מלא</label>
            <TextField
              fullWidth
              id="full_name"
              value={formValues.full_name}
              onChange={(e) => handleInputChange('full_name', e.target.value)}
              variant="outlined"
              size={inputSize}
              sx={{ ...commonStyles, fontSize: window.innerWidth < 1460 ? '14px' : '16px' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment 
                    sx={{ position: 'absolute', left: '14px', pointerEvents: 'none', cursor: 'pointer' }}
                    position="start"
                  >
                    <img
                      src={inputWriteIcon}
                      alt="edit"
                      style={{ width: '20px', height: '20px'}}
                    />
                  </InputAdornment>
                )
              }}
            />
          </div>

          <div className='pro_input'>
            <label>ת.ז</label>
            <TextField
              fullWidth
              id="idNumber"
              value={formValues.idNumber}
              onChange={(e) => handleInputChange('idNumber', e.target.value)}
              variant="outlined"
              size={inputSize}
              sx={{ ...commonStyles, fontSize: window.innerWidth < 1460 ? '14px' : '16px' }}
              // disabled={userIDNum ? true : false}
            />
          </div>
        </div>

        <div className='pro_row_input'>
          <div className='pro_input'>
            <label>טלפון נייד</label>
            <TextField
              fullWidth
              id="phone_number"
              value={formValues.phone_number}
              variant="outlined"
              size={inputSize}
              sx={{ ...commonStyles, fontSize: window.innerWidth < 1460 ? '14px' : '16px' }}
              disabled
            />
          </div>

          <div className='pro_input'>
            <label>כתובת אימייל</label>
            <TextField
              fullWidth
              id="email"
              value={formValues.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              variant="outlined"
              size={inputSize}
              sx={{ ...commonStyles, fontSize: window.innerWidth < 1460 ? '14px' : '16px' }}
              type='email'
              InputProps={{
                startAdornment: (
                  <InputAdornment 
                    sx={{ position: 'absolute', left: '14px', pointerEvents: 'none', cursor: 'pointer' }}
                    position="start"
                  >
                  <img
                    src={inputWriteIcon}
                    alt="edit"
                    style={{ width: '20px', height: '20px'}}
                  />
                  </InputAdornment>
                )
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
